import { Article } from './../../../catalog.model';
import { Description } from './../../../../erp-common/erp-common.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA   } from '@angular/material/dialog';
import { DictionaryEntry } from '@sdbn/common';

@Component({
  selector: 'app-description-editor',
  templateUrl: './description-editor.component.html',
  styleUrls: ['./description-editor.component.scss']
})
export class DescriptionEditorComponent implements OnInit {

  article: Article;

  description: Description;
  originalDescription: Description;

  formGroup = new FormGroup({});

  isNew = false;

  constructor(
    public dialogRef: MatDialogRef<DescriptionEditorComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.article != null) {
      this.article = data.article;
    }

    if (data.description != null) {
      this.originalDescription = data.description;
      this.description = new Description(data.description);
      this.isNew = false;
    } else {
      this.description = new Description({});
      this.isNew = true;
    }

    console.log(this.description);

    this.formGroup.addControl('usage', new FormControl(false, []));
  }

  ngOnInit(): void {

    this.formGroup.patchValue({
      usage: this.description?.usage
    });

    this.formGroup.valueChanges.subscribe(formValues => {
      this.description.usage = formValues.usage;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {

    if (this.isNew && this.article != null && this.description != null) {
      this.article.descriptions.push(this.description);
    } else if (this.originalDescription != null) {
      this.originalDescription.text = this.description.text;
      this.originalDescription.title = this.description.title;
      this.originalDescription.usage = this.description.usage;
    }

    this.dialogRef.close();
  }

  confirmDisabled(): boolean {
    return !this.formGroup.valid || this.description?.title == null || !this.description?.title.checkValueExistsForLanguage('de');
  }

  public onTitleChanged(dictionary: DictionaryEntry) {
    this.description.title = new DictionaryEntry(dictionary);
  }

  public onTextChanged(dictionary: DictionaryEntry) {
    this.description.text = new DictionaryEntry(dictionary);
  }

}
